import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { WorkflowRunStatus } from '../models/workflowRun';
import { workflowRunSchema } from '../models/workflowRun.schema';
import { workflowRunsListQuerySchema } from './list.schema';

export type WorkflowRunsListQuery = Partial<{
  annotation: ID | ID[];
  workflowStatus: WorkflowRunStatus;
}> &
  PaginationQuery;

export const list = (query: WorkflowRunsListQuery = {}) => {
  return {
    endpoint: `/workflow_runs`,
    method: 'GET',
    responseSchema: listResponse(workflowRunSchema),
    query: { ...query, includeTotal: true },
    querySchema: workflowRunsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
